<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- boton crear -->
    <v-row class="pt-0" v-if="componenteEvento.agregar_submodulo">
      <v-col class="d-flex flex-row-reverse pt-0">
        <TableButtonComp
          normalButton
          iconBut="fas fa-plus"
          textButton="Crear perfil"
          @click="addItem"
        />
      </v-col>
    </v-row>

    <!-- fin boton  crear-->

    <!-- /////////////////////////////////////////////////////
             //             PANTALLA PRINCIPAL DE PERFILES      //
             /////////////////////////////////////////////////////    -->

    <!-- seccion de la tabla de webmaster -->
    <v-row>
      <v-col cols="12">
        <ComundataTableComp
          placeholderTextsearch="Bucar perfiles"
          :items="Datos"
          :headers="GestionPerfilWebmasterheaders"
          rowsPerPageText="Perfiles por página:"
          noResultsText="Sin perfiles por mostrar"
          whitSearch
        >
          <template v-slot:estadoValor="{ item }">
            <v-chip
              small
              :class="
                item.estado_perfil === 1 ? ' color_activo' : ' color_inactivo'
              "
            >
              {{ item.estado_perfil === 1 ? "Activo" : "Inactivo" }}
            </v-chip>
          </template>

          <template v-slot:action_editar="{ item }">
            <TableButtonComp
              v-if="componenteEvento.editar_submodulo"
              editButton
              tooltipText="Editar perfil"
              @click="editItem(item)"
            />
          </template>

          <template v-slot:action_borrar="{ item }">
            <TableButtonComp
              v-if="componenteEvento.borrar_submodulo"
              tooltipText="Borrar perfil"
              deleteButton
              @click="deleteConfirm(item)"
            />
          </template>

          <template v-slot:action_config="{ item }">
            <TableButtonComp
              v-if="componenteEvento.editar_submodulo"
              :disabled="item.estado_perfil === 0"
              tooltipText="Configurar módulos del perfil"
              configButton
              @click="configPerfil(item.id)"
            />
          </template>
        </ComundataTableComp>
      </v-col>
    </v-row>

    <!-- fin de pantalla principal -->

    <!-- /////////////////////////////////////////////////////
             //         MODAL DE AGREGAR DE PERFILES            //
        /////////////////////////////////////////////////////    -->
    <v-form ref="formDatos" lazy-validation>
      <v-dialog v-model="dialog" persistent scrollable max-width="480px">
        <v-card>
          <v-card-title class="btn_otro">
            <label>{{ formTitle }}</label>
            <v-spacer />
            <v-btn fab dark x-small class="btn_style3" @click="dialog = false"
              ><v-icon dark>fa-times</v-icon></v-btn
            >
          </v-card-title>

          <v-divider></v-divider>
          <v-card-text class="px-5 py-10" >
            <v-text-field
              style="max-width:320px"
              max-width="100px"
              v-model="editedItem.descripcion_perfil"
              label="Nombre"
              :rules="[rul.required, rul.max100]"
            ></v-text-field>
            <template v-if="this.metodo == 'editar'">
              <v-conteiner class="px-0">
                <label>Estado:</label>
                <v-radio-group class="pl-3 mt-0" v-model="editedItem.estado_perfil"  hide-details>
                  <v-radio :label="`Activo`" :value="1" color="teal"></v-radio>
                  <v-radio
                    :label="`Inactivo`"
                    :value="0"
                    color="error"
                  ></v-radio>
                </v-radio-group>
              </v-conteiner>
            </template>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer />
            <v-btn class="btn_style3" dark  @click="dialog = false"
              >Cancelar</v-btn
            >
            <v-btn
              class="btn_block_style2"
              :disabled="guardandoPerfil"
              
              v-if="this.metodo == 'editar'"
              @click="saveItem(editedItem.id)"
              >Guardar Cambios</v-btn
            >
            <v-btn
              class="btn_block_style2"
              :disabled="guardandoPerfil"
              
              v-if="this.metodo == 'agregar'"
              @click="saveItem"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!-- fin de modal agregar perfil -->

    <!-- /////////////////////////////////////////////////////
        //         MODAL DE BORRAR REGISTROS                  //
        /////////////////////////////////////////////////////    -->
    <v-dialog v-model="dialog_delete" max-width="550px">
      
      <v-card>
        <v-card-title class="btn_ver py-3" >
          Borrar perfil
          <v-spacer />
          <v-btn
            fab
            dark
            x-small
            class="btn_style3"
            @click="dialog_delete = false"
            ><v-icon dark>fa-times</v-icon></v-btn
          >
        </v-card-title>

        <v-card-text class="text-center black--text pt-8">
          <h3>
            ¿Está seguro de que desea borrar este registro?
          </h3>
          <div class="py-6">
            <div class="yellow py-2 px-3  rounded-pill mx-3" style="font-size:1rem">
            <span >{{ desc_delete }}</span>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_style3" dark  @click="dialog_delete = false"
            >No</v-btn
          >
          <v-btn class="btn_block_style2" dark  @click="deleteItem"
            >Si</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- fin de modal de borrar registro -->

    <!-- /////////////////////////////////////////////////////
        //         MODAL DE CONFIGURACION DE PERFIL        //
        /////////////////////////////////////////////////////    -->
    <v-form ref="formPerfilConfig" lazy-validation>
      <v-dialog v-model="dialogConfig" persistent scrollable min-width="400px" >
        <v-card class="" >
          <v-card-title class="btn_otro">
            Configuración de módulos
            <v-spacer />
            <v-btn
              fab
              dark
              x-small
              class="btn_style3"
              @click="dialogConfig = false"
              ><v-icon dark>fa-times</v-icon></v-btn
            >
          </v-card-title>

          <v-divider />

          <v-card-text class="modulo_configuracion_modulos py-5">
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="configuracion.id_perfil"
                  :items="perfil"
                  label="Perfil"
                  @change="cargarSubModulo"
                  item-value="id"
                  item-text="descripcion_perfil"
                  :rules="[rul.selectReq]"
                >
                </v-select>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  label="Tipo de licencia"
                  v-model="configuracion.id_licencia_tipo"
                  :items="licenciaTipo"
                  @change="cargarSubModulo"
                  item-value="id"
                  item-text="desc_tipo_licencia"
                  :rules="[rul.selectReq]"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="configuracion.id_modulo"
                  :items="modulo"
                  label="Módulo"
                  @change="cargarSubModulo"
                  item-value="id"
                  item-text="nombre_modulo"
                  :rules="[rul.selectReq]"
                >
                </v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="6" xs="12" class="d-none d-sm-flex">
                <v-row>
                  <v-col cols class="py-0">
                    <label class="font-weight-black black--text">
                      <h3>Submódulos</h3>
                    </label>
                  </v-col>

                  <v-col cols="1" class="py-0 btn_ver d-flex justify-center">
                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" dark x-small>fa-eye</v-icon>
                      </template>
                      <span>VISUALIZAR</span>
                    </v-tooltip>
                  </v-col>

                  <v-col cols="1" class="py-0 btn_otro d-flex justify-center">
                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <div class="grid">
                          <v-icon dark x-small v-on="on">fa-plus</v-icon>
                        </div>
                      </template>
                      <span>AGREGAR</span>
                    </v-tooltip>
                  </v-col>

                  <v-col cols="1" class="py-0 btn_editar d-flex justify-center">
                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-icon dark x-small v-on="on">fa-pencil-alt</v-icon>
                      </template>
                      <span>EDITAR</span>
                    </v-tooltip>
                  </v-col>

                  <v-col
                    cols="1"
                    class="py-0 btn_eliminar d-flex justify-center"
                  >
                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-icon dark x-small v-on="on">fa-trash-alt</v-icon>
                      </template>
                      <span>BORRAR</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="6" md="6" xs="12">
                <v-row>
                  <v-col cols class="py-0">
                    <label class="font-weight-black black--text">
                      <h3>Submódulos</h3>
                    </label>
                  </v-col>

                  <v-col cols="1" class="py-0 d-flex justify-center btn_ver">
                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-icon dark x-small v-on="on">fa-eye</v-icon>
                      </template>
                      <span>VISUALIZAR</span>
                    </v-tooltip>
                  </v-col>

                  <v-col cols="1" class="py-0 d-flex justify-center btn_otro">
                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-icon dark x-small v-on="on">fa-plus</v-icon>
                      </template>
                      <span>AGREGAR</span>
                    </v-tooltip>
                  </v-col>

                  <v-col cols="1" class="py-0 d-flex justify-center btn_editar">
                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-icon dark x-small v-on="on">fa-pencil-alt</v-icon>
                      </template>
                      <span>EDITAR</span>
                    </v-tooltip>
                  </v-col>

                  <v-col
                    cols="1"
                    class="py-0 d-flex justify-center btn_eliminar"
                  >
                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-icon dark x-small v-on="on">fa-trash-alt</v-icon>
                      </template>
                      <span>BORRAR</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-col>

              <!--
                                // recorro los Sub Modulos
                                // y asigno el array del modelo que se chequea  confSubModuloV
                            -->
            </v-row>
            <v-row>
              <v-col
                cols="12"
                xs="12"
                sm="6"
                md="6"
                v-for="item in this.confSubModulo"
                :key="item.id"
              >
                <v-row>
                  <v-col cols class="py-0">
                    <label class="black--text">{{
                      item.nombre_submodulo
                    }}</label>
                  </v-col>

                  <v-col cols="1" class="px-0 py-0">
                    <div class="d-flex justify-center">
                      <v-checkbox
                        hide-details
                        v-model="confSubModuloV"
                        :value="item.id"
                        class="my-0"
                        color="#388e3c"
                      />
                    </div>
                  </v-col>

                  <v-col cols="1" class="px-0 py-0">
                    <div class="d-flex justify-center">
                      <v-checkbox
                        v-model="confSubModuloA"
                        :value="item.id"
                        class="my-0"
                        color="#01579b"
                        hide-details
                      />
                    </div>
                  </v-col>

                  <v-col cols="1" class="px-0 py-0">
                    <div class="d-flex justify-center">
                      <v-checkbox
                        v-model="confSubModuloE"
                        :value="item.id"
                        class="my-0"
                        color="#ffbc00"
                        hide-details
                      />
                    </div>
                  </v-col>

                  <v-col cols="1" class="px-0 py-0">
                    <div class="d-flex justify-center">
                      <v-checkbox
                        v-model="confSubModuloD"
                        :value="item.id"
                        class="my-0"
                        color="#e53935"
                        hide-details
                      />
                    </div>
                  </v-col>
                </v-row>

                <v-divider />
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn_style3" dark  @click="dialogConfig = false"
              >Cancelar</v-btn
            >
            <v-btn class="btn_block_style2" dark  @click="saveConfig"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!-- fin de modal de configuracion perfil -->
  </div>
</template>


<style>

  /* ESTO ES PARA BORRAR ESA LINEA QUE ATRAVIEZA LOS CHECKBOX */
  .modulo_configuracion_modulos .row hr{
    display: none;
  }
</style>


<script>
import axios from "../../helpers/axios";
import { GestionPerfilWebmasterheaders } from "../../helpers/headersTable.js";
import ComundataTableComp from "../../components/ComponentsEst/ComundataTablecomp.vue";
import TableButtonComp from "../../components/ComponentsEst/TableButtonComp.vue";
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  components: {
    ComundataTableComp,
    TableButtonComp,
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 20, id_modulo: 4 }, //sud_modulo y modulo
    GestionPerfilWebmasterheaders,
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////

    dialog: false,
    dialogConfig: false,

    dialog_delete: false,
    desc_delete: null,
    id_delete: null,

    metodo: null,
    search: "",

    guardandoPerfil: false,

    Datos: [],
    modulo: [],
    perfil: [],

    confPerfil: [],
    configuracion: {}, // objeto de configuracion
    licenciaTipo: [],
    confSubModulo: [],

    // Perfil Chequeados
    confSubModuloV: [],
    confSubModuloA: [],
    confSubModuloE: [],
    confSubModuloD: [],

    titulo: "perfil",
    formTitle: "",
    editedItem: [],

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo Requerido",
      inputReq: (value) => !!value || "Campo Requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
    },
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },

  mounted() {
    setTimeout(() => {
      this.loadMain();
    }, 800);
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //  ------- Cargar todos los registros principales al iniciar el componente   --------
    async loadMain() {
      try {
        let response = await axios.get("/sistema/perfil/webmaster");
        console.log({data:response.data});
        this.Datos = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async limpiarForm() {
      this.editedItem = {
        id_usuario: this.datoLogin.id,
        id_colegio: 0,
        id: 0,
        descripcion_perfil: "",
        es_webmaster: 1,
        estado: 1,
      };

      this.resetValidation();
    },

    // Validar resetear campos al guardar
    resetValidation() {
      this.$refs.formDatos.resetValidation();
    },

    //----------- AREGAR REGISTROS  --------------
    async addItem() {
      this.limpiarForm();
      this.formTitle = "Crear " + this.titulo;
      this.dialog = true;
      this.metodo = "agregar";
    },

    //--------------EDITAR REGISTRO--------------
    editItem(item) {
      this.limpiarForm();
      this.formTitle = "Editar " + this.titulo;
      this.dialog = true;
      this.metodo = "editar";

      this.editedItem = Object.assign({}, item);
    },

    // Guarda los Perfiles
    async saveItem() {
      if (this.$refs.formDatos.validate()) {
        try {
          this.guardandoPerfil = true;
          if (this.metodo == "agregar") {
            const res = await axios.post("/sistema/perfil", this.editedItem);
            console.log(res);
            this.setEnviarMens({
              tipo: "S",
              mensaje: `¡Información creada con éxito!`,
              tiempo: null,
            });
          }

          if (this.metodo == "editar") {
            const res = await axios.put(
              "/sistema/perfil/" + this.editedItem.id,
              this.editedItem
            );
            console.log(res);
            this.setEnviarMens({
              tipo: "S",
              mensaje: `¡Información editada con éxito!`,
              tiempo: null,
            });
          }
          this.guardandoPerfil = false;

          this.loadMain();
          this.dialog = false;
          this.metodo = null;
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },

    // activa la modal para confirmar el borrar el registro
    deleteConfirm(items) {
      this.dialog_delete = true;
      this.id_delete = items.id;
      this.desc_delete = `${items.descripcion_perfil} - (${items.id})`;
    },

    //------------BORRAR Registro -------------
    async deleteItem() {
      this.dialog_delete = false;
      try {
        let resp = await axios.delete("/sistema/perfil/" + this.id_delete);
        this.loadMain();
        this.dialog = false;
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async limpiarFormConfig() {
      this.confSubModulo = [];
      this.configuracion = {
        id_perfil: "",
        id_licencia_tipo: "",
        id_modulo: null,
      };

      this.$refs.formPerfilConfig.resetValidation();
    },

    // Configuracion de Perfil
    async configPerfil(item) {
      this.limpiarFormConfig();

      this.dialogConfig = true;

      try {
        let response = await axios.get("/sistema/perfil/confManager");
        this.perfil = response.data.perfil;
        this.modulo = response.data.modulo;
        this.licenciaTipo = response.data.licenciaTipo;

        if (this.licenciaTipo == null || this.licenciaTipo == "") {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `No existen tipo de licencia asociada al colegio`,
            tiempo: null,
          });
        }
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: e, tiempo: null });
      }

      // url  /sistema/perfil/configuracion  // traer datos
      this.configuracion.id_perfil = item;
      //this.configuracion.id_modulo = null

      this.confSubModuloV = [];
      this.confSubModuloA = [];
      this.confSubModuloE = [];
      this.confSubModuloD = [];
    },

    // carga las consultas de los submodulos segun el modulo seleccionad
    async cargarSubModulo() {
      if (
        this.configuracion.id_perfil != null &&
        this.configuracion.id_modulo != null
      ) {
        try {
          let response = await axios.post(
            "/sistema/perfil/confSubModuloPerfil",
            this.configuracion
          );

          this.confSubModulo = response.data.subModulo;
          this.confSubModuloV = response.data.confSubModuloV;
          this.confSubModuloA = response.data.confSubModuloA;
          this.confSubModuloE = response.data.confSubModuloE;
          this.confSubModuloD = response.data.confSubModuloD;
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },

    // Guarda la configuración de perfil
    async saveConfig() {
      if (this.$refs.formPerfilConfig.validate()) {
        try {
          let params = {
            configuracion: this.configuracion,
            subModulo: this.confSubModulo,
            confSubModuloV: this.confSubModuloV,
            confSubModuloA: this.confSubModuloA,
            confSubModuloE: this.confSubModuloE,
            confSubModuloD: this.confSubModuloD,
            id_usuario: this.datoLogin.id,
          };
          const res = await axios.post("/sistema/perfil/saveConfig", params);
          console.log(res);

          this.setEnviarMens({
            tipo: "S",
            mensaje: `¡Información editada con éxito!`,
            tiempo: null,
          });
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },
  },
};
</script>
